<!-- 首页 -->
<template>
    <div>
        <div class="header">
            <div class="card" v-for="(item, index) of lists" :key="index">
                <img class="wh128" :src="item.img" />
                <div class="card-div">
                    <div class="card-txt">
                        <div>{{ item.name }}</div>
                        <Icon type="ios-arrow-forward" />
                    </div>
                    <div class="card-num">{{ item.num }}</div>
                </div>
            </div>
        </div>
        <div class="content">
            <div class="content-title">账号数量增长趋势</div>
            <EchartBar
                v-if="isLoading"
                class="content-bar"
                id="one"
                :xAxisData="xAxisData"
                :seriesData="seriesData"
            ></EchartBar>
        </div>
    </div>
</template>
<script>
import { plat_index_account, plat_index_list } from "@/api/index";
import { EchartBar } from "@/components/eChart/index";
export default {
    components: {
        EchartBar,
    },
    data() {
        return {
            lists: [
                {
                    img: require("@/assets/logo1.png"),
                    name: "当前账号数量",
                    num: "",
                },
                {
                    img: require("@/assets/logo2.png"),
                    name: "即将到期账号数量",
                    num: "",
                },
                {
                    img: require("@/assets/logo3.png"),
                    name: "已到期账号数量",
                    num: "",
                },
            ],
            isLoading: false,
            xAxisData: [],
            seriesData: [],
        };
    },
    mounted() {
        this.getPlatIndexAccount();
        this.getPlatIndexList();
    },
    methods: {
        getPlatIndexAccount() {
            plat_index_account().then((res) => {
                this.lists[0].num = res.data[0].count_num;
                this.lists[1].num = res.data[0].expire_num;
                this.lists[2].num = res.data[0].deactivate_num;
            });
        },
        getPlatIndexList() {
            plat_index_list().then((res) => {
                res.data.forEach((item) => {
                    this.xAxisData.push(item.date);
                    this.seriesData.push(item.val.num);
                });
                this.isLoading = true;
            });
        },
    },
};
</script>

<style scoped>
.content {
    padding: 24px;
    background: #ffffff;
    box-shadow: 0px 0px 4px 0px rgba(82, 102, 136, 0.1);
    border-radius: 5px;
}
.header {
    margin-bottom: 24px;
    display: flex;
    align-content: center;
    justify-content: space-between;
}
.card {
    margin-right: 24px;
    padding: 24px;
    display: flex;
    align-items: center;
    background: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 10px;
    width: 100%;
}
.card:last-child {
    margin-right: 0;
    padding: 24px;
    display: flex;
    align-items: center;
    background: #ffffff;
    box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px;
    border-radius: 10px;
    width: 100%;
}
.wh128 {
    width: 128px;
    height: 128px;
}
.card-div {
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    width: 100%;
    height: 80px;
}
.card-txt {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;
    font-size: 20px;
    font-weight: 400;
    color: #999999;
}
.card-num {
    font-size: 38px;
    font-weight: 400;
    color: #333333;
}
.content-title {
    font-size: 16px;
    font-weight: 700;
    color: #20253a;
}
.content-bar {
    width: 90%;
    min-height: 500px;
}
</style>